import { InfoOrganizerAction } from "Pages/InfoOrganizerPage/Redux/actions";

export interface IInfoOrganizer {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.OrganizerPageViewModel;
};

const initialInfoOrganizer: IInfoOrganizer = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoOrganizer(
  state: IInfoOrganizer = initialInfoOrganizer, 
  action: InfoOrganizerAction,
  ): IInfoOrganizer {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_ORGANIZER_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_ORGANIZER_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_ORGANIZER_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoOrganizer;


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/Redux/reducer.tsx